module.exports = __webpack_public_path__ + "media/images/icon/file-pdf-solid-3ecb61fd2aa48624e68df2e84178219f.svg";